/* ============================================================
   Bedtextielonline — "Terug naar je selectie" (custom, Claude)

   Collectie- en zoekpagina's: onthoudt (sessionStorage, enkel dit
   tabblad) de laatst bekeken lijst: URL incl. filters/sortering/
   pagina, titel, leesbare filterlabels en scrollpositie.

   Productpagina's: vult de grote tegel "Terug naar ..." in de
   sectie btol-verder-shoppen in en zet een kleine terug-link
   bovenaan de productinfo. Zonder bewaarde lijst blijft de tegel
   op de Liquid-fallback ("Alle ... bekijken") en komt er geen
   link bovenaan.

   Terugklikken via de tegel of link herstelt de scrollpositie.
   ============================================================ */
(function () {
  var KEY = 'btol_laatste_selectie';
  var RESTORE = 'btol_herstel_scroll';

  function load() {
    try { return JSON.parse(sessionStorage.getItem(KEY)); } catch (e) { return null; }
  }

  function save(value) {
    try { sessionStorage.setItem(KEY, JSON.stringify(value)); } catch (e) {}
  }

  function clean(text) {
    return String(text || '').replace(/\s+/g, ' ').replace(/\s*\(\d+\)\s*$/, '').trim();
  }

  function actieveFilters() {
    var out = [];

    function add(text) {
      text = clean(text);
      if (text && text.length <= 60 && out.indexOf(text) === -1) out.push(text);
    }

    /* 1. labels van aangevinkte filters (leesbaarste bron) */
    var inputs = document.querySelectorAll('input[name^="filter."]:checked');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var label = null;
      try {
        if (input.id) label = document.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      } catch (e) {}
      if (!label) label = input.closest('label');

      var text = label ? clean(label.textContent) || label.getAttribute('aria-label') || label.title : '';
      if (!clean(text)) {
        text = input.getAttribute('aria-label') || input.title || (/^gid:/.test(input.value) ? '' : input.value);
      }
      add(text);
    }

    var params = new URLSearchParams(location.search);

    /* 2. fallback: waarden uit de URL */
    if (!out.length) {
      params.forEach(function (value, key) {
        if (key.indexOf('filter.') !== 0 || /price/.test(key)) return;
        if (/availability/.test(key)) {
          if (value === '1') add('Op voorraad');
          return;
        }
        if (!/^gid:/.test(value)) add(value);
      });
    }

    /* 3. prijsfilter */
    var min = params.get('filter.v.price.gte');
    var max = params.get('filter.v.price.lte');
    if (min || max) add('€' + (min || '0') + ' – €' + (max || '…'));

    return out.slice(0, 4);
  }

  /* ---------- collectie- / zoekpagina ---------- */
  var lijst = window.btolSelectie;

  if (lijst) {
    var bewaar = function () {
      save({
        url: location.pathname + location.search,
        titel: lijst.titel,
        filters: actieveFilters(),
        y: Math.round(window.scrollY || 0)
      });
    };

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href*="/products/"]');
      if (link) bewaar();
    }, true);

    window.addEventListener('pagehide', bewaar);

    var herstel = null;
    try {
      herstel = sessionStorage.getItem(RESTORE);
      sessionStorage.removeItem(RESTORE);
    } catch (e) {}

    if (herstel) {
      var vorige = load();
      if (vorige && vorige.url === location.pathname + location.search && vorige.y > 0) {
        var scroll = function () { window.scrollTo(0, vorige.y); };
        if (document.readyState === 'complete') {
          setTimeout(scroll, 80);
        } else {
          window.addEventListener('load', function () { setTimeout(scroll, 80); });
        }
      }
    }
    return;
  }

  /* ---------- productpagina ---------- */
  function markeer(link) {
    link.addEventListener('click', function () {
      try { sessionStorage.setItem(RESTORE, '1'); } catch (e) {}
    });
  }

  function init() {
    var tegel = document.querySelector('[data-btol-terug-tegel]');
    var bewaard = load();

    if (!bewaard || !bewaard.url || !bewaard.titel) return;

    if (tegel) {
      tegel.href = bewaard.url;

      var titel = tegel.querySelector('[data-btol-terug-titel]');
      if (titel) titel.textContent = 'Terug naar ' + bewaard.titel;

      var filters = tegel.querySelector('[data-btol-terug-filters]');
      if (filters) {
        filters.textContent = bewaard.filters && bewaard.filters.length
          ? 'Jouw filters: ' + bewaard.filters.join(' · ')
          : 'Verder kijken waar je gebleven was';
      }
      markeer(tegel);
    }

    var info = document.querySelector('.product-info');
    if (info && !document.querySelector('.btol-terug-top')) {
      var link = document.createElement('a');
      link.className = 'btol-terug-top';
      link.href = bewaard.url;
      link.textContent = '← Terug naar ' + bewaard.titel;
      link.style.cssText = 'display:inline-block;margin:0 0 12px;font-size:15px;font-weight:600;color:#2a2940;text-decoration:underline;text-underline-offset:3px;';
      markeer(link);
      info.insertBefore(link, info.firstChild);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
